import { useState } from "react";

/** 初回、または依存値が Object.is 比較で変わった場合に true を返す。 */
export const depsChanged = (previous: readonly unknown[] | null, dependencies: readonly unknown[]): boolean =>
  previous === null ||
  previous.length !== dependencies.length ||
  dependencies.some((dependency, index) => !Object.is(dependency, previous[index]));

/**
 * props / URL などの変更に合わせ、このコンポーネント自身のローカル state を同期する。
 * supplier-frontend と同様、初回にも同期し、同じ依存値での再描画では同期しない。
 *
 * sync は描画中に実行する。このコンポーネント自身の useState の setter だけを呼ぶこと。
 * 通信、DOM / ref の参照、router、共有 atom、親への通知には使用しない。
 * 依存値には、内部の state 更新だけでは参照が変わらない値を渡すこと。
 */
export const useSyncOnChange = (dependencies: readonly unknown[], sync: () => void): void => {
  const [previous, setPrevious] = useState<readonly unknown[] | null>(null);
  if (depsChanged(previous, dependencies)) {
    setPrevious(dependencies);
    sync();
  }
};
